import axios from 'axios';
import { backendURL } from '../App';
import { useQuery } from 'react-query';

const getClientAnketaData = async (_, anketaID) => {
  const { data } = await axios({
    method: 'get',
    url: `${backendURL}user/anketa/`,
    headers: {
      Authorization: `Token ${localStorage.getItem('skillsSurveyUserToken')}`,
    },
    params: {
      anketa_id: anketaID,
    },
  });
  return data;
};

export default function useClientAnketaData(anketaID) {
  return useQuery(['clientAnketaData', anketaID], getClientAnketaData, {
    // Конечный retry: react-query 2.x с retry:true бесконечно крутится в loading
    // и НЕ выставляет .error — из-за этого ErrorInfiniteRetry не мог отличить
    // network от HTTP-ошибки. С retry=3 + backoff через ~3.5с status='error' и
    // реальный axios-объект уходит в компонент → ветки делятся корректно.
    retry: 3,
    retryDelay: (attempt: number) => Math.min((attempt + 1) * 500, 3000),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    staleTime: Infinity,
  });
}
